import { render, staticRenderFns } from "./_Contacts.vue?vue&type=template&id=a3032cc4"
import script from "./_Contacts.vue?vue&type=script&lang=js"
export * from "./_Contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports